import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowsDiagonalOutOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.1 2H22v7.9h-1.8V5.073l-5.464 5.463-1.272-1.272L18.927 3.8H14.1zm-3.564 12.736L5.073 20.2H9.9V22H2v-7.9h1.8v4.827l5.464-5.463z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowsDiagonalOutOutlinedSize24Glyph.displayName = 'ArrowsDiagonalOutOutlinedSize24Glyph';
